import consumer from './consumer';

let signatureSubscription = null;
let docliftDoesNotAnswerTimer = null;
let iframe;

function setupSignatureChannel() {
  // This function is executed after 3mn if Doclift does not answer
  function docliftDoesNotAnswer() {
    if (!(typeof iframe === 'object')) {
      consumer.disconnect();
      document.getElementById('subscriptionStep2')?.classList.add('d-none');
      document.getElementById('subscriptionStep3')?.classList.add('d-none');
      document.getElementById('subscriptionStep4')?.classList.add('d-none');
      document.getElementById('subscriptionStepError')?.classList.remove('d-none');
    }
  }

  function generateUniversignIframe(signerId) {
    const configuration = {};
    const subscriptionStep3 = document.getElementById('subscriptionStep3');
    const iframeEndpoint = subscriptionStep3?.dataset.universignIframeEndpoint;
    /**
     * The universignSigInit function add an iframe element as child of element with
     * id attribute equals to containerId parameter, the attribute src is set from
     * the universignUrl variable, it is the url of the website to be integrated in
     * the iframe, the width and height of the iframe will take 100% of its
     * container.
     *
     * @param {string} containerId The id of the element in which we will inject
     * the iframe.
     * @param {string} signerId The identifier of transaction.
     * @param {object} configuration The options list to customize the iframe:
     * * redirectionMode {string} This params have two possible values: IN or OUT,
     * the dafault value is OUT,
     * if the value of this params is equal to OUT the redirection will be done
     * outside the iframe(in website container of the iframe),
     * if the value of this params is equal to ÌN the redirection will be done
     * inside the iframe,
     * if the value of this params is otherwise, an exception will be triggered.
     **/

    universignSigInit('subscriptionStep3', signerId, configuration, iframeEndpoint);
  }

  function generateContractIframe(documentUrl) {
    iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '86%';
    iframe.src = documentUrl;

    const subscriptionStep3 = document.getElementById('subscriptionStep3');
    subscriptionStep3?.prepend(iframe);

    const editSubscriptionForm = document.querySelector('.edit_subscription');
    editSubscriptionForm?.addEventListener('ajax:success', function (event) {
      document.getElementById('subscriptionStep3')?.classList.add('d-none');
      document.getElementById('subscriptionStep4')?.classList.remove('d-none');

      const breadcrumbElement3 = document.querySelector('.breadcrumb-element:nth-child(3)');
      breadcrumbElement3?.classList.remove('current');
      breadcrumbElement3?.classList.add('past');

      const breadcrumbElement4 = document.querySelector('.breadcrumb-element:nth-child(4)');
      breadcrumbElement4?.classList.remove('next');
      breadcrumbElement4?.classList.add('current');

      const currentStep = document.getElementById('current_step');
      if (currentStep) currentStep.textContent = '4';
    });
  }

  const signatureSubscriptionElement = document.getElementById('signature-subscription-id');
  if (!signatureSubscriptionElement) {
    return;
  }

  docliftDoesNotAnswerTimer = setTimeout(docliftDoesNotAnswer, 180000);

  signatureSubscription = consumer.subscriptions.create(
    { channel: 'SignatureChannel', subscription_id: signatureSubscriptionElement.dataset.id },
    {
      received(data) {
        try {
          if (data.status === 'success') {
            clearTimeout(docliftDoesNotAnswerTimer);

            if (data.e_sign_id !== undefined) {
              generateUniversignIframe(data.e_sign_id);
            } else {
              generateContractIframe(data.document_url);
            }

            // Enable the button to load the contract and display the success message
            const contractLoadedButton = document.getElementById('contractLoadedButton');
            if (contractLoadedButton) contractLoadedButton.disabled = false;

            const subscriptionStep2 = document.getElementById('subscriptionStep2');
            const stepTitle = subscriptionStep2?.querySelector('#step-title');
            if (stepTitle) stepTitle.textContent = subscriptionStep2.dataset.titleInCaseOfDocReady;

            const stepImage = subscriptionStep2?.querySelector('#step-image');
            if (stepImage) stepImage.src = subscriptionStep2.dataset.imageInCaseOfDocReady;

            document.getElementById('generatingDocInProgressExplanations')?.classList.add('d-none');
            document.getElementById('generatingDocReadyExplanations')?.classList.remove('d-none');

            contractLoadedButton?.addEventListener('click', (_event) => {
              document.getElementById('subscriptionStep3')?.classList.remove('d-none');
              document.getElementById('subscriptionStep2')?.classList.add('d-none');

              const breadcrumbElement2 = document.querySelector('.breadcrumb-element:nth-child(2)');
              breadcrumbElement2?.classList.remove('current');
              breadcrumbElement2?.classList.add('past');

              const breadcrumbElement3 = document.querySelector('.breadcrumb-element:nth-child(3)');
              breadcrumbElement3?.classList.remove('next');
              breadcrumbElement3?.classList.add('current');

              const currentStep = document.getElementById('current_step');
              if (currentStep) currentStep.textContent = '3';
            });
          } else {
            setTimeout(() => {
              document.getElementById('subscriptionStep2')?.classList.add('d-none');
              document.getElementById('subscriptionStep3')?.classList.add('d-none');
              document.getElementById('subscriptionStep4')?.classList.add('d-none');
              document.getElementById('subscriptionStepError')?.classList.remove('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            document.getElementById('subscriptionStep2')?.classList.add('d-none');
            document.getElementById('subscriptionStep3')?.classList.add('d-none');
            document.getElementById('subscriptionStep4')?.classList.add('d-none');
            document.getElementById('subscriptionStepError')?.classList.remove('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          document.getElementById('subscriptionStep2')?.classList.add('d-none');
          document.getElementById('subscriptionStep3')?.classList.add('d-none');
          document.getElementById('subscriptionStep4')?.classList.add('d-none');
          document.getElementById('subscriptionStepError')?.classList.remove('d-none');
        }, 5000);
        this.uninstall();
      },
    },
  );
}

function teardownSignatureChannel() {
  if (signatureSubscription) {
    consumer.subscriptions.remove(signatureSubscription);
    signatureSubscription = null;
  }

  clearTimeout(docliftDoesNotAnswerTimer);
  docliftDoesNotAnswerTimer = null;
  iframe = undefined;
}

document.addEventListener('turbo:load', setupSignatureChannel);
document.addEventListener('turbo:before-cache', teardownSignatureChannel);
